import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import SubNavbar from '../components/SubNavbar';
import ActionButton from '../../ActionButton';
import { routes } from '../../../pages';
import { getRouteName } from '../../../utils/routesNames';

import './_campaignsNav.scss';

const CampaignsNav = ({ redirect = false }) => {
  const { pathname } = useLocation();
  const baseCommissionRate = useSelector(s => s.baseCommissionRate);

  return (
    <div className="campaignsNav">
      {/*<SubNavbar route={`${getRouteName(pathname)} ${!isEmpty(dataTable) ? '(' + dataTable.length + ')' : ''}`}>*/}
      <SubNavbar route={getRouteName(pathname)}>
        {redirect && <ActionButton disabled={!baseCommissionRate.data.domain} variant="secondary" title="Create" to={routes.campaigns.create.path}/>}
      </SubNavbar>
    </div>
  );
};

CampaignsNav.propTypes = {
  redirect: PropTypes.bool
};

export default CampaignsNav;